module.exports = "/fonts/themify.eot?2c454669bdf3aebf32a1bd8ac1e0d2d6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/themify-icons/fonts/themify.eot
// module id = 23
// module chunks = 23